/* Step 12 add-on G3 (11d-4 report) — the reporting framework on the create-engagement form (optional). The value chosen is
   stored by POST /engagements with the Engagement settings rule ("full" | "sme") and an Audit Trail row "Reporting framework
   set"; not chosen = today's default (not set — chosen later in Engagement settings). EN + AR: lib/i18n/2150_s12f2_fixes.js. */
import React from "react";
import { Label } from "@/components/ui/label";
import { useI18n } from "@/contexts/I18nContext";

export default function CreateReportingFramework({ value, onChange }) {
  const { t } = useI18n();
  const opts = [["", t("s12f2.rf.notChosen")], ["full", t("engSettings.rfFull")], ["sme", t("engSettings.rfSme")]];
  return (
    <div className="rounded-md border border-amber-200 bg-amber-50/60 p-3 dark:border-amber-900 dark:bg-amber-950/20"
         data-testid="eng-rf-create">
      <Label className="text-xs font-semibold">{t("engSettings.repFramework")}</Label>
      <div className="mt-2 flex gap-2" role="radiogroup" aria-label={t("engSettings.repFramework")} data-testid="eng-rf-group">
        {opts.map(([val, label]) => {
          const active = (value || "") === val;
          return (
            <button key={val || "none"} type="button" role="radio" aria-checked={active} onClick={() => onChange(val)}
                    className={`flex-1 rounded-md border px-3 py-1.5 text-sm transition ${active
                      ? "border-amber-500 bg-white font-semibold text-amber-800 shadow-sm dark:bg-slate-900"
                      : "border-amber-200 bg-transparent text-slate-600 hover:bg-white"}`}
                    data-testid={`eng-rf-${val || "none"}`}>
              {label}
            </button>
          );
        })}
      </div>
      <div className="mt-1 text-[10px] text-muted-foreground">{t("s12f2.rf.optional")}</div>
    </div>
  );
}
